module.exports = __webpack_public_path__ + "img/图像26.bb28e9d5.png";